import { ActionModalTypes, SwapOrReturnData, SwapOrReturnTypeNames } from '../../SwapOrReturnTypes'
import Modal from 'src/components/Modal'
import * as S from './SwapOrReturnActionsModal.styles'

interface SwapOrReturnActionsModalProps {
  show: boolean
  swapOrReturnData: SwapOrReturnData
  onAction: (type: SwapOrReturnTypeNames, operation: ActionModalTypes) => void
  onClose: () => void
}

const SwapOrReturnActionsModal: React.FC<SwapOrReturnActionsModalProps> = ({
  show, swapOrReturnData, onAction, onClose,
}) => {
  const { swap, return: returnData } = swapOrReturnData

  return (
    <Modal
      show={show}
      testId='swap-or-return-actions-modal-test-id'
      centered
      title='Escolha a próxima ação'
      closeButtonAction={onClose}
      body={(
        <S.Container>
          <S.CustomButton
            title={swap ? 'Editar Troca' : 'Criar Troca'}
            bgColor='lightBlue5'
            hoverColor='darkBlueHover2'
            letterColor='white'
            data-testid='swap-button-test-id'
            onClick={() => onAction(SwapOrReturnTypeNames.SWAP, swap ? ActionModalTypes.EDIT : ActionModalTypes.CREATE)}
          />
          <S.CustomButton
            title={returnData ? 'Editar Devolução' : 'Criar Devolução'}
            bgColor='orange'
            hoverColor='darkOrangeHover'
            letterColor='white'
            data-testid='return-button-test-id'
            onClick={() => onAction(SwapOrReturnTypeNames.RETURN, returnData ? ActionModalTypes.EDIT : ActionModalTypes.CREATE)}
          />
        </S.Container>
      )}
    />
  )
}

export default SwapOrReturnActionsModal
